import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { MultiSelect } from '@/components/ui/multi-select';
import { X } from 'lucide-react';

interface FilterFieldProps {
  question: {
    id: number;
    key: string;
    label: string;
    type: string;
    options?: Array<{ value: string; label: string }>;
  };
  value: any;
  onChange: (value: any) => void;
}

export function FilterField({ question, value, onChange }: FilterFieldProps) {
  switch (question.type) {
    case 'select':
    case 'radio':
      return (
        <div className="space-y-2">
          <Label htmlFor={question.key} className="text-sm font-medium">
            {question.label}
          </Label>
          <Select
            value={value || ''}
            onValueChange={(val) => onChange(val === '_clear_' ? null : val)}
          >
            <SelectTrigger 
              id={question.key}
              className="w-full"
            >
              <SelectValue placeholder="Any" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="_clear_" className="text-muted-foreground">
                <span className="italic">Any (clear filter)</span>
              </SelectItem>
              {question.options?.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      );

    case 'multi_select':
      return (
        <div className="space-y-2">
          <Label className="text-sm font-medium">{question.label}</Label>
          <MultiSelect
            options={question.options || []}
            defaultValue={Array.isArray(value) ? value : []}
            onValueChange={(values) => onChange(values.length > 0 ? values : null)}
            placeholder="Select options..."
            maxCount={2}
            className="w-full"
          />
        </div>
      );

    case 'string':
    case 'text':
      return (
        <div className="space-y-2">
          <Label htmlFor={question.key} className="text-sm font-medium">
            {question.label}
          </Label>
          <div className="relative">
            <Input
              id={question.key}
              type="text"
              value={value || ''}
              onChange={(e) => onChange(e.target.value || null)}
              placeholder={`Any`}
              className="pr-8"
            />
            {value && (
              <button
                onClick={() => onChange(null)}
                className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
              >
                <X className="h-4 w-4" />
              </button>
            )}
          </div>
        </div>
      );

    default:
      return null;
  }
}